import { Fragment } from "react";
import { HTMLVisualElement } from "../html/HTMLVisualElement.js";
import { SVGVisualElement } from "../svg/SVGVisualElement.js";
import { isSVGComponent } from "./utils/is-svg-component.js";
const createDomVisualElement = (Component, options) => {
  return isSVGComponent(Component) ? new SVGVisualElement(options, { enableHardwareAcceleration: false }) : new HTMLVisualElement(options, {
    allowProjection: Component !== Fragment,
    enableHardwareAcceleration: true
  });
};
export {
  createDomVisualElement
};
//# sourceMappingURL=create-visual-element.js.map
